import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { Button } from '../../components/button/button-component';
import { Typography } from '../../components/typography/typography-component';

export default function Releaseloghero() {
  return (
    <div className="mb-14 grid grid-cols-1 gap-8 py-16 lg:grid-cols-2">
      <div className="flex w-full flex-col items-center lg:items-start lg:px-10 lg:py-20">
        <Typography
          variant="h1"
          className="text-center text-5xl font-semibold text-[#27292C] lg:text-left"
        >
          The changelog tool for SaaS
        </Typography>
        <Typography
          variant="lead"
          className="my-4 mb-6 mr-5 text-center text-lg lg:text-left"
        >
          Send out beautiful feature announcements and product updates to your
          users in minutes.
          <br />
          <br />
          Perfect for busy Founders that want to keep their users engaged.
        </Typography>

        <Link target="_blank" href="https://releaselog.io/signup">
          <Button
            size="lg"
            variant="filled"
            className="mx-1 mt-10 bg-[#FF914D] px-10 py-5 font-avenir shadow-lg hover:bg-[#FF914D]"
          >
            Start For Free
          </Button>
        </Link>
      </div>

      <div className="relative flex justify-center lg:justify-end">
        <Image
          className="max-w-full shadow-lg md:max-w-[80%]"
          src="/assets/releaselog.webp"
          alt="hero graphic 1"
          height={600}
          width={600}
        />
      </div>
    </div>
  );
}
